export const roundAmount = (number: any) =>
  isNaN(number) ? 0 : Number(parseFloat(number || 0).toFixed(2))
